module.exports = __webpack_public_path__ + "media/images/ui__textArrowUpAccent-dc12882c1a85126d235f674073aed346.png";